import request from "@/utils/request";
import { TMPURL } from "./config";

// 获取游戏列表
export function apiGetGameList(params) {
  return request.get(TMPURL + "/v1/public/game/list", params);
}

// 客服首页kv列表
export function apiGetKfKvList(params) {
  return request.get(TMPURL + "/v1/public/kf/kvList", params);
}

// 上报伍六七埋点uid
export function apiTrackLog(params) {
  return request.post(TMPURL + "/v1/public/kf/trackLog", params);
}

// 获取红包code
export function apiGetRedEnvelope(params) {
  return request.post(
    TMPURL + "/v1/public/selfService/getRedeemCode ",
    params,
    false,
    false
  );
}
